import { render } from "./UsuariosTable.vue?vue&type=template&id=07900ef8"
import script from "./UsuariosTable.vue?vue&type=script&lang=js"
export * from "./UsuariosTable.vue?vue&type=script&lang=js"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__